export default __webpack_public_path__ + "assets/9d5d54ca2f9d7c9d54aa1fca15aa587a.jpg";